import { AxiosInstance } from 'axios';
import { initAxios } from 'utils/axios';
import config from 'config/Config';
import { JsonApiResource, JsonApiResponse } from 'types/store/jsonApi';

const learningTeamsFiltersPath = 'common/learning-teams';

export interface LearningTeamsFilterAttributes {
  name: string;
}

export interface InsightFilterOptions {
  learningTeams: JsonApiResource<LearningTeamsFilterAttributes>[];
}

class insightFiltersAPI {
  private axiosInstance: AxiosInstance = initAxios(
    config.get('insightsFiltersBackendURL')
  );

  async getFilters(): Promise<InsightFilterOptions> {
    try {
      const { data } = await this.axiosInstance.get<
        JsonApiResponse<LearningTeamsFilterAttributes>
      >(learningTeamsFiltersPath);

      const learningTeams =
        data.data as JsonApiResource<LearningTeamsFilterAttributes>[];

      return {
        learningTeams,
      };
    } catch (error) {
      throw new Error(
        `Failed to fetch filters from ${learningTeamsFiltersPath}: ${error}`
      );
    }
  }
}

export default insightFiltersAPI;
